export const MaxProjectScreenerQuestions = 5;

export const NotApplicableRankingOrdinal = 0;
